import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../partner/facilityInternalRequestApproval/ContextAPI';
import Index from '../partner/facilityInternalRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityInternalRequestPartnerApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-internal-request-partner-approval'])
        return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
